/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2024-2025 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'alertifyjs/build/css/themes/bootstrap.css';


/**
 * Basic notification service
 */
class Notify {
    constructor() {
        alertify.set('notifier','delay', 10);
        alertify.defaults.glossary.title = '';
        alertify.defaults.moveable = false;
        alertify.defaults.theme.ok = "btn-blue btn btn-primary";
        alertify.defaults.theme.cancel = "btn-simple btn btn-secondary";
    }
    
    info(msg) {
        alertify.success(msg);
    }

    warn(msg){
        alertify.warning(msg);
    }

    error(msg) {
        alertify.error(msg);
    }

    confirm(msg, okFn, cancelFn = null) {
        // confirm dialog
        alertify.confirm(msg, okFn, cancelFn).set('reverseButtons', true).set('moveable', false);
    }

    dismiss(){
        alertify.dismissAll();
    }

}

const notify = new Notify();

export default notify;
